import { IModuleConfiguration, ModuleConfiguration } from 'src/types/system_types';
import { IViewModuleConfiguration } from './view_module';

import $ip from'../../../pip/library/pi-ip/pi-ip.js';
import f1 from'../../../pip/library/pi-f1/pi-f1.js';

export interface ISentryModuleConfiguration extends IModuleConfiguration {
  /**
   * data source name(DSN) that Sentry provides (Settings folder)
   * when you create a project in Sentry
   */
  dsn: string;
}

export class SentryModule extends ModuleConfiguration {
  configuration: ISentryModuleConfiguration;
  Sentry: any;

  /**
   *
   * @param configuration
   */
  initialize(configuration: ISentryModuleConfiguration) {
    return new Promise((resolve) => {
      this.configuration = this.__defaultConfiguration(configuration);
      $ip
        .require('@eab-hip/library/sentry/sentry.js')
        .then((Sentry) => (this.Sentry = Sentry))
        .then(() => resolve(this.configuration));
    });
  }

  activate(configuration: { view: IViewModuleConfiguration }) {
    return new Promise((resolve, reject) => {
      if (this.configuration.dsn === '') {
        reject('no dns');
      }

      const view = configuration.view;
      const environment = view.constants['@environment'];
      const release = view.constants['@release'];

      this.Sentry.init({
        dsn: this.configuration.dsn,
        environment,
        release
      });

      resolve(configuration);
    });
  }

  private __defaultConfiguration(configuration: ISentryModuleConfiguration) {
    return f1.merge(
      'over',
      {
        dns: ''
      },
      configuration
    ) as ISentryModuleConfiguration;
  }
}
